<template>
  <b-row class="live-info" v-if="live">
    <b-col class="col-12 col-lg-7">
      <div class="d-flex">
        <div>
          <router-link :to="{name: 'artist-about', params: { artistId: this.artist.id }}"><img class="artist-avatar" :src="artist.avatar_image"></router-link>
        </div>
        <div>
          <h4>{{ live.title }}</h4>
          <small>
            By
            <router-link :to="{name: 'artist-about', params: { artistId: this.artist.id }}">{{ artist.name }}</router-link>
            {{ liveStartsIn }}
          </small>
        </div>
      </div>
    </b-col>
    <b-col class="col-12 col-lg-5 text-right">
      <span class="viewed"><font-awesome-icon icon="eye" /> {{ live.viewer_count }}</span>
      <span :class="likeClass"><font-awesome-icon icon="heart" @click="like" /> {{ live.rate_count }}</span>
      <span class="comments"><font-awesome-icon icon="comment" /> {{ live.comment_count }}</span>
      <div class="actions">
        <LinkButton :id="'btnShareStream' + live.id" v-if="isLoggedIn" >
          <font-awesome-icon icon="share" />Share
        </LinkButton>
        <Share :target="'btnShareStream' + live.id" v-if="isLoggedIn" />
        <router-link class="white-link" :to="{ name: 'account-login', query: { next: $route.fullPath }}" v-if="!isLoggedIn">
          <font-awesome-icon icon="share" />Share
        </router-link>

        <Pay :live="live" @ticket="$emit('ticket', $event)" @join="$emit('join', $event)" v-if="!attending" />

        <b-button class="btn-rainbow" id="liveDonate" v-if="attending">
          <img src="/static/icons/donate.svg">
          Donate
        </b-button>
        <Donate :live="live" :artist="live.artist" target="liveDonate" v-if="attending" />
      </div>
    </b-col>
  </b-row>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .white-link {
    color: $white;
  }

  .live-info {
    margin-top: 1em;
    display: flex;
    align-items: center;
    margin-bottom: 1em;
    border-bottom: 1px solid $steel;
    padding-bottom: 1em;

    img.artist-avatar {
      float: left;
      width: 48px;
      height: 48px;
      border-radius: 100%;
      margin-right: 1em;
      @include media-breakpoint-down(xs) {
        margin-bottom: 1.8em;
      }
    }

    h4 {
      margin-bottom: 0;
    }

    small {
      color: $steel;
    }

    span {
      margin-left: 1em;
    }

    .like {
      &:hover {
        color: $darkish-pink;
      }

      &.disabled:hover {
        color: white;
      }

      &.already-liked {
        color: $darkish-pink;
      }
    }

    .actions {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: flex-end;
      margin-top: 0.5em;
      align-items: center;

      #liveDonate {
        font-family: 'AvenirHeavy';
        padding: 0.5em 1.5em 0.5em 1.5em;
        margin-left: 1em;
      }
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import moment from '@/utils/moment'

import Share from '@/components/widgets/Share'
import Pay from '@/components/widgets/Pay'
import LinkButton from '@/components/widgets/LinkButton'
import Donate from '@/components/widgets/Donate'

export default {
  name: 'LiveInfo',
  components: {
    FontAwesomeIcon,
    Pay,
    Share,
    LinkButton,
    Donate
  },
  props: {
    live: Object,
    attending: Boolean
  },
  data () {
    return {
      ticket: null
    }
  },
  computed: {
    artist () {
      return this.live ? this.live.artist : {}
    },
    liveStartsIn () {
      return moment(this.live.start).fromNow()
    },
    likeClass () {
      let cls = ['like']
      if (this.live && this.live.rated_by_user) cls.push('already-liked')
      if (!this.isLoggedIn) cls.push('disabled')
      return cls
    },
    ...mapGetters('auth', ['isLoggedIn'])
  },
  methods: {
    async like () {
      if (!this.live) return

      if (this.live.rated_by_user) {
        await this.$store.dispatch('live/unlikeLiveEvent', {id: this.live.id})
        this.live.rated_by_user = false
        this.live.rate_count--
      } else {
        await this.$store.dispatch('live/likeLiveEvent', {id: this.live.id})
        this.live.rated_by_user = true
        this.live.rate_count++
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/LiveInfo.vue